import "core-js/modules/es.regexp.exec.js";
import { addPvNew, isBaiduMap, isBaiduMapAuto, getUrlParams } from '../../../utils';
import { reportActionToRedies } from '../utils';
import openmore from './openmore.vue';
import { noteOpenClickBury } from '../bury';
import { isScreenOptimization } from '../abtestConfig.js';
// 行高
const lineHeight = 24;
export default {
  components: {
    'open-more': openmore
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    abtest: {
      type: String,
      default: ''
    },
    dataIndex: {
      type: Number,
      default: -1
    },
    unique_id: {
      type: String,
      default: ''
    },
    guide: {
      type: Object,
      default: () => {}
    },
    isPush: {
      type: Boolean,
      default: false
    },
    phoneInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    panelStyle: {
      type: Boolean,
      default: false
    },
    // 点击查看全文是否展示全部
    isClickShow: {
      type: Boolean,
      default: true
    },
    author: {
      type: Object,
      default() {
        return {};
      }
    },
    poiLink: {
      type: String,
      default: ''
    }
  },
  data() {
    const params = getUrlParams(location.href);
    const {
      source = ''
    } = params || {};
    return {
      showMore: false,
      commentTextHeight: 0,
      tpSource: '',
      isBaiduMap: isBaiduMap(),
      isBaiduMapAuto: isBaiduMapAuto(),
      // 是否在车机地图中
      source: source
    };
  },
  mounted() {
    const {
      tpSource = ''
    } = this.guide || {};
    this.tpSource = tpSource;
    setTimeout(() => {
      this.contentLineHandle();
      this.showHandle();
    }, 0);
  },
  computed: {
    heightStyle() {
      if (this.commentTextHeight > 0) {
        // 高度减3为了兼容，文本是空行，空行文本的高度是26px，导致文本头部漏出所以减3
        const height = this.commentTextHeight * 2 - 3;
        return {
          height: this.pxToVw(height)
        };
      }
      return {
        height: 'auto'
      };
    },
    textLineNum() {
      const isOpenScreen = this.source.includes('openscreen');
      if (isScreenOptimization) {
        // 对照组：默认折叠2行
        return 2;
      } else if (this.abtest.includes('106352') || isOpenScreen) {
        // 实验组：默认折叠3行
        return 3;
      }
      // 未命中实验的和线上保持一致，默认折叠3行
      return 3;
    }
  },
  watch: {
    text() {
      this.$nextTick(() => {
        this.contentLineHandle();
      });
    }
  },
  methods: {
    // 超过三行，收起内容并显示展开
    // 行高的n倍再加10像素的必定会超过n行
    // panelStyle - 页面中的正文组件默认收起，面板中的正文panelStyle为true，直接全展开
    contentLineHandle() {
      const isFeedTextHeight = this.$refs.feedText && this.$refs.feedText.clientHeight;
      if (!this.panelStyle && isFeedTextHeight > lineHeight * 2 + 10) {
        // 首篇默认3行收起，开屏数据(source值包含openscreen时)，都默认3行
        this.showMore = true;
        this.commentTextHeight = lineHeight * this.textLineNum;
      }
    },
    /**
     * 将像素值转换为视口宽度百分比值（vw）
     *
     * @param px 像素值
     * @returns 转换后的视口宽度百分比值（vw）
     */
    pxToVw(px) {
      const designWidth = 750; // 与 LESS 文件中的 @designWidth 保持一致
      return px * 100 / designWidth + 'vw';
    },
    /**
     * 展开内容
     */
    handleOpen() {
      noteOpenClickBury(this.dataIndex);
      // 上报action
      reportActionToRedies({
        unique_id: this.unique_id
      }, this.dataIndex, 'click_expand', this.phoneInfo);
      // 新展开交互不在当前页面展开，会弹出面板
      if (!this.isClickShow) {
        this.showMore = true;
      } else {
        this.showMore = false;
        this.commentTextHeight = 0;
      }
      this.$emit('content-open');
    },
    showHandle() {
      const spanElement = document.getElementById('commentText' + this.dataIndex);
      // 查找当前组件内部可跳转节点
      const blueElements = spanElement.querySelectorAll('.microBlue');
      if (!blueElements) {
        return;
      }
      if (!this.isBaiduMap && !this.isBaiduMapAuto) {
        blueElements.forEach(ele => {
          ele.addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation();
            this.$emit('open-Baidu-Map');
          });
        });
      }

      // 监听对象
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          // 如果目标元素进入视窗
          if (entry.intersectionRatio > 0) {
            const showElement = entry.target;
            this.buryHandle(showElement, 'show');
            // 曝光上报完成，取消观察该元素
            observer.unobserve(showElement);
          }
        });
      });

      // 遍历这些元素并开始观察它们
      blueElements.forEach(function (element) {
        observer.observe(element);
      });
    },
    // 埋点处理
    buryHandle(showElement, type) {
      const {
        className: elementClassName = '',
        href: hrefVal = '',
        textContent: elementText = ''
      } = showElement || {};
      addPvNew(['NewMedia.detailspage.poitextpoi.' + type], {
        style: hrefVal.includes('map/place/detail') ? 'precise' : hrefVal.includes('search') ? 'general' : 'other',
        tp: this.tpSource,
        tag_word: elementClassName.includes('tag_word') ? elementText : 0,
        extract_name: /extract|precise/.test(elementClassName) ? elementText : 0,
        general_word: elementClassName.includes('general_word') ? elementText : 0,
        query_word: elementClassName.includes('query_word') ? elementText : 0,
        feed_id: this.unique_id
      });
    },
    // 通过事件代理获取点击事件并上报埋点
    contentClick(e) {
      const clickedElement = e.target;
      if ((clickedElement === null || clickedElement === void 0 ? void 0 : clickedElement.tagName) === 'A') {
        this.buryHandle(clickedElement, 'click');
      } else {
        this.handleContentClick();
      }
    },
    // 点击正文区域（非飘蓝），展开全文
    handleContentClick() {
      if (this.showMore) {
        this.handleOpen();
      }
    }
  }
};